import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  ORDER_DETAILS_ACTIONS,
  useTrackOrderDetailsAction,
} from '../../modals/order-details-modal/event-tracking/use-track-order-details-action';
import { launchVoidModal } from '../../../store/labels/labels.actions';

const useOpenVoidModal = ({ fulfillment }) => {
  const dispatch = useDispatch();
  const trackShipmentsVoidClick = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.SHIPMENTS_VOID);

  return useCallback(() => {
    const mappedFulfillment = [
      {
        fulfillmentId: fulfillment.fulfillmentId,
        serviceId: fulfillment.serviceId || fulfillment?.returnConfiguration?.serviceId,
        carrierId: fulfillment.carrierId || fulfillment?.returnConfiguration?.carrierId,
        trackingInformation: fulfillment.trackingInformation,
      },
    ];
    dispatch(launchVoidModal({ fulfillments: mappedFulfillment }));
    trackShipmentsVoidClick();
  }, [fulfillment, dispatch, trackShipmentsVoidClick]);
};

export default useOpenVoidModal;
